// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import PipIndicator from '@deere/cps-it.warranty-model-factory/lib/pip-indicator';

const pipText = {
    COMPLETED: {
        text: 'COMPLETED'
    },
    EXPIRED: {
        text: 'EXPIRED_PIPS'
    },
    NONE: {
        text: 'NO_OPEN_PIPS'
    },
    OPEN: {
        text: 'OPEN_PIPS'
    }
};

const pipClass = {
    NONE: {
        displayClass: ''
    },
    RED: {
        displayClass: 'dot-icon-red'
    },
    YELLOW: {
        displayClass: 'dot-icon-yellow'
    }
};

const PipStatus = props => {

    const displayClass = props.pipIndicator.color ?
        pipClass[props.pipIndicator.color].displayClass : '';

    const text = pipText[props.pipIndicator.status].text;

    const linkOptions = props.openInNewTab ? {target: '_blank'} : null;

    return (
        <div className='pip-status'>
            <span className={displayClass}/>
            <a
                {...linkOptions}
                href={`#/pips/search?by=PIN&q=${encodeURIComponent(props.pin)}`}
            >
                <FormattedMessage id={text}/>
            </a>
        </div>
    );

};

PipStatus.displayName = 'PipStatus';
PipStatus.propTypes = {
    openInNewTab: PropTypes.bool,
    pin: PropTypes.string.isRequired,
    pipIndicator: PropTypes.instanceOf(PipIndicator).isRequired
};

PipStatus.defaultProps = {
    openInNewTab: false
};

export default PipStatus;



// WEBPACK FOOTER //
// ./src/product/shared/components/pip-status.js